import { useState } from 'react';

export default function MasonryFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does stucco installation cost in El Paso?',
      answer: 'Stucco installation in El Paso typically costs between $6 to $12 per square foot, including materials and labor. Traditional three-coat cement stucco runs $8-$12/sq ft, while synthetic EIFS systems cost $6-$9/sq ft. A 2,000 sq ft home exterior might cost $12,000-$24,000. Factors include surface preparation, texture type, and project complexity. Always get multiple quotes.'
    },
    {
      question: 'How long does stucco last in El Paso\'s climate?',
      answer: 'Properly installed and maintained stucco can last 50-80 years in El Paso. The dry desert climate is actually ideal for stucco, as it prevents moisture-related issues common in humid regions. Traditional cement stucco is extremely durable. Regular inspections, prompt crack repairs, and occasional repainting help maximize lifespan.'
    },
    {
      question: 'What causes stucco cracks and how are they repaired?',
      answer: 'Stucco cracks result from settling, temperature fluctuations, improper installation, or moisture intrusion. Hairline cracks under 1/8" are normal and easily patched with elastomeric caulk. Larger cracks require professional repair involving cleaning, filling with stucco patch, re-texturing, and painting. Addressing cracks promptly prevents water damage and further deterioration.'
    },
    {
      question: 'Is stone veneer or natural stone better for my home?',
      answer: 'Both have advantages. Natural stone offers authentic beauty and exceptional durability but costs more ($15-$30/sq ft installed) and requires skilled installation. Manufactured stone veneer provides similar appearance at lower cost ($8-$15/sq ft), weighs less, and installs faster. For most homeowners, quality manufactured stone offers excellent value and appearance.'
    },
    {
      question: 'Do I need permits for masonry work in El Paso?',
      answer: 'Permits depend on project scope. Minor repairs typically don\'t require permits. New construction, structural work, retaining walls over 4 feet, and significant exterior modifications usually need permits. Your contractor should handle permit applications and ensure work meets El Paso building codes. Always verify requirements with the city before starting.'
    },
    {
      question: 'How do I maintain stucco in El Paso?',
      answer: 'Inspect stucco annually for cracks, stains, or damage. Clean with garden hose or pressure washer (low setting) to remove dirt and dust. Repair cracks promptly before they worsen. Repaint every 5-7 years to maintain protection and appearance. Ensure proper drainage away from foundation. Trim vegetation to prevent moisture retention against walls.'
    },
    {
      question: 'What\'s the difference between stucco and EIFS?',
      answer: 'Traditional stucco is cement-based, applied in multiple coats over wire lath, offering superior durability and breathability. EIFS (Exterior Insulation Finishing System) uses foam board insulation with synthetic acrylic finish, providing better energy efficiency and design flexibility. EIFS is lighter and faster to install but requires proper installation to prevent moisture issues.'
    },
    {
      question: 'Can masonry work be done year-round in El Paso?',
      answer: 'Yes, El Paso\'s mild winters allow year-round masonry work. However, extreme heat in summer (over 100°F) can affect mortar curing and requires special precautions like frequent water misting and shade. Ideal temperatures are 40-90°F. Professional contractors adjust techniques and schedules based on weather conditions to ensure quality results.'
    },
    {
      question: 'How long does a typical masonry project take?',
      answer: 'Timeline varies by project size and complexity. Stucco installation on a standard home takes 1-2 weeks. Stone veneer accent walls take 3-5 days. Large commercial projects may take several weeks. Weather, surface preparation, and curing time affect schedules. Your contractor will provide a detailed timeline based on your specific project.'
    },
    {
      question: 'What should I look for when hiring a masonry contractor?',
      answer: 'Verify licensing and insurance, check references and online reviews, review their portfolio of completed projects, get detailed written estimates from multiple contractors, ensure they offer warranties, confirm they handle permits and inspections, assess their knowledge of materials and techniques, and evaluate their communication and professionalism. Never pay the full amount upfront.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about masonry and stucco services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-teal-500 transition-all">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
